<template>
  <div class="table-container-inner">
    <table>
      <thead>
      <tr class="tr-fixed-height">
        <th
            class="metall-received-count"
            scope="col"
            rowspan="3"
        >
          № п/п
        </th>
        <th
            class="metall-received-count"
            scope="col"
            rowspan="3"
        >
          Администратор (структурное подразделение)
        </th>
        <th
            class="metall-received-count"
            scope="col"
            rowspan="3"
        >
          Группа товаров
        </th>
        <th
            class="metall-received-count"
            scope="col"
            rowspan="3"
        >
          Код ТМЦ (согласно учетной системы)
        </th>
        <th
            class="metall-received-count"
            scope="col"
            rowspan="3"
        >
          Наименование ТМЦ
        </th>
        <th
            class="metall-received-count"
            scope="col"
            rowspan="3"
        >
          Ед. изм.
        </th>
        <th
            class="metall-received-count"
            scope="col"
            rowspan="2"
            colspan="4"
        >
          Остатки за предыдущие фин.годы
        </th>
        <th
            class="metall-received-count"
            scope="col"
            rowspan="1"
            colspan="9"
        ></th>
        <th
            class="metall-received-count"
            scope="col"
            rowspan="2"
            colspan="2"
        >
          Остаток на конец отчетного месяца
        </th>
      </tr>
      <tr>
        <th colspan="2">Поступило ТМЦ</th>
        <th colspan="3">Реализовано/Списано</th>
        <th colspan="2">
          Переведено в категорию металлолом
        </th>
        <th colspan="2">
          Переведено в категорию утилизирован
        </th>
      </tr>
      <tr>
        <th>Дата поступления</th>
        <th>Кол-во</th>
        <th>Цена</th>
        <th>Сумма</th>
        <th>Кол-во</th>
        <th>Сумма</th>
        <th>Кол-во</th>
        <th>Сумма</th>
        <th>Виды реализации</th>
        <th>Кол-во</th>
        <th>Сумма</th>
        <th>Кол-во</th>
        <th>Сумма</th>
        <th>Кол-во</th>
        <th>Сумма</th>
      </tr>
      </thead>
      <tbody
          v-for="(request, index) in this.illiquidReportRequest"
          :key="request.id"
      >
      <tr>
        <td>{{ index + 1 }}</td>
        <td>{{ request.abp }}</td>
        <td>{{ request.category }}</td>
        <td>{{ request.code_tmc }}</td>
        <td>{{ request.name_tmc }}</td>
        <td>{{ request.measure_unit }}</td>
        <td v-if="!request.broken_years">
          {{
            request.remains_before_tmz_delivery_date
                | formatDateTwo
          }}
        </td>
        <td v-else>---</td>
        <td>
          {{
            request.remains_before_tmz_count
                | getNumberFormatTmz
          }}
        </td>
        <td v-if="!request.broken_years">
          {{
            request.remains_before_tmz_price
                | getNumberFormatTmz
          }}
        </td>
        <td v-else>---</td>
        <td>
          {{
            request.remains_before_tmz_sum
                | getNumberFormatTmz
          }}
        </td>
        <td>
          {{ request.come_tmc_count | getNumberFormatTmz }}
        </td>
        <td>
          {{ request.come_tmc_sum | getNumberFormatTmz }}
        </td>
        <td>
          {{
            request.implemented_tmc_count
                | getNumberFormatTmz
          }}
        </td>
        <td>
          {{
            request.implemented_tmc_sum
                | getNumberFormatTmz
          }}
        </td>
        <td>{{ request.implemented_tmc_type }}</td>
        <td>
          {{
            request.transferred_to_metal_count
                | getNumberFormatTmz
          }}
        </td>
        <td>
          {{
            request.transferred_to_metal_sum
                | getNumberFormatTmz
          }}
        </td>
        <td>
          {{
            request.transferred_to_util_count
                | getNumberFormatTmz
          }}
        </td>
        <td>
          {{
            request.transferred_to_util_sum
                | getNumberFormatTmz
          }}
        </td>
        <td>
          {{
            request.remains_after_tmz_count
                | getNumberFormatTmz
          }}
        </td>
        <td>
          {{
            request.remains_after_tmz_sum
                | getNumberFormatTmz
          }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>


<script>
export default {
  props: ['report'],
  data() {
    return {
      illiquidReportRequest: ''
    }
  },
  watch: {
    report: function (newVal) {
      this.illiquidReportRequest = newVal
    }
  },
  mounted() {
    this.illiquidReportRequest = this.report
  }
}
</script>

<style scoped>
.table-container-inner {
  padding: 0.5rem;
  margin: 0 2rem;
  /* padding: 1rem 2rem; */
  /* margin-right: 2rem; */
  /* margin: 1rem 2rem; */
  max-height: 65vh;
  overflow: auto;
  max-width: 100vw;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin: 0 auto 2rem;
  overflow-x: auto;
  border-bottom: 1px solid black;
  font-size: 14px;
}

th,
td {
  border: 1px solid #868686;
  padding: 0 1rem;
}
</style>
